export async function fetchContactCreate(formData: ContactFormData) {
  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client
  const isB2B = formData.type === 'b2b'
  const hasRouteGclidParam = !!route.query.gclid

  return await $fetch
    .raw('/contact', {
      baseURL: runtimeConfig.public.apiBaseURL,
      method: 'post',
      body: {
        ...formData,
        client,
        ...(isB2B &&
          hasRouteGclidParam && {
            gclid: route.query.gclid as string,
          }),
      },
    })
    .catch((error) => {
      return error.data
    })
}
